import { render, staticRenderFns } from "./invoice-grid.vue?vue&type=template&id=525a76a4"
import script from "./invoice-grid.ts?vue&type=script&lang=js&external"
export * from "./invoice-grid.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports